import { LICENSE_DEGA } from '~/utils/license-utils';

export const FILTER_JACKPOT = 'jackpot';

const ROUTE_SLOTS = '/slots';
const ROUTE_CASINO = '/casino';

const ROUTE_LIVE_SLOTS = '/live-slots';
const ROUTE_LIVE_CASINO = '/live-casino';

const ROUTE_GAME = '/game';
const ROUTE_EXPLORE = '/explore';
const ROUTE_SUBMENU = '/submenu';
const ROUTE_MY_GAMES = '/my-games';
const ROUTE_MY_GAMES_LOVED = `${ROUTE_MY_GAMES}/loved`;
const ROUTE_MY_GAMES_RECENT = `${ROUTE_MY_GAMES}/playedOrder`;
const ROUTE_PROVIDER = '/provider';
const ROUTE_SUBPROVIDER = '/subprovider';
const ROUTE_ALL_GAMES = '/all-games';
const ROUTE_JACKPOT = `${ROUTE_ALL_GAMES}/${FILTER_JACKPOT}`;
const ROUTE_QUICK_DEPOSIT = '/quick-deposit';
const ROUTE_SEARCH = '/search';

// Casino paths
export const CASINO_PATHS = [ROUTE_CASINO, ROUTE_SLOTS] as const;
export const CASINO_GAME_PATHS = [`${ROUTE_SLOTS}${ROUTE_GAME}`, `${ROUTE_CASINO}${ROUTE_GAME}`] as const;
export const CASINO_EXPLORE_PATHS = [`${ROUTE_SLOTS}${ROUTE_EXPLORE}`, `${ROUTE_CASINO}${ROUTE_EXPLORE}`] as const;
export const CASINO_SUBMENU_PATHS = [`${ROUTE_SLOTS}${ROUTE_SUBMENU}`, `${ROUTE_CASINO}${ROUTE_SUBMENU}`] as const;
export const CASINO_MY_GAMES_PATHS = [
	`${ROUTE_SLOTS}${ROUTE_MY_GAMES}`,
	`${ROUTE_CASINO}${ROUTE_MY_GAMES}`,
	`${ROUTE_SLOTS}${ROUTE_MY_GAMES_LOVED}`,
	`${ROUTE_CASINO}${ROUTE_MY_GAMES_LOVED}`,
	`${ROUTE_SLOTS}${ROUTE_MY_GAMES_RECENT}`,
	`${ROUTE_CASINO}${ROUTE_MY_GAMES_RECENT}`
] as const;
export const CASINO_ALL_GAMES_PATHS = [
	`${ROUTE_SLOTS}${ROUTE_ALL_GAMES}`,
	`${ROUTE_CASINO}${ROUTE_ALL_GAMES}`,
	`${ROUTE_SLOTS}${ROUTE_JACKPOT}`,
	`${ROUTE_CASINO}${ROUTE_JACKPOT}`
] as const;
export const CASINO_PROVIDER_PATHS = [`${ROUTE_SLOTS}${ROUTE_PROVIDER}`, `${ROUTE_CASINO}${ROUTE_PROVIDER}`] as const;
export const CASINO_SUBPROVIDER_PATHS = [
	`${ROUTE_SLOTS}${ROUTE_SUBPROVIDER}`,
	`${ROUTE_CASINO}${ROUTE_SUBPROVIDER}`
] as const;
export const CASINO_SEARCH_PATHS = [`${ROUTE_SLOTS}${ROUTE_SEARCH}`, `${ROUTE_CASINO}${ROUTE_SEARCH}`] as const;

// Live casino paths
export const LIVE_CASINO_PATHS = [ROUTE_LIVE_CASINO, ROUTE_LIVE_SLOTS] as const;
export const LIVE_CASINO_GAME_PATHS = [
	`${ROUTE_LIVE_SLOTS}${ROUTE_GAME}`,
	`${ROUTE_LIVE_CASINO}${ROUTE_GAME}`
] as const;
export const LIVE_CASINO_EXPLORE_PATHS = [
	`${ROUTE_LIVE_SLOTS}${ROUTE_EXPLORE}`,
	`${ROUTE_LIVE_CASINO}${ROUTE_EXPLORE}`
] as const;
export const LIVE_CASINO_SUBMENU_PATHS = [
	`${ROUTE_LIVE_SLOTS}${ROUTE_SUBMENU}`,
	`${ROUTE_LIVE_CASINO}${ROUTE_SUBMENU}`
] as const;
export const LIVE_CASINO_MY_GAMES_PATHS = [
	`${ROUTE_LIVE_SLOTS}${ROUTE_MY_GAMES}`,
	`${ROUTE_LIVE_CASINO}${ROUTE_MY_GAMES}`,
	`${ROUTE_LIVE_SLOTS}${ROUTE_MY_GAMES_LOVED}`,
	`${ROUTE_LIVE_CASINO}${ROUTE_MY_GAMES_LOVED}`
] as const;
export const LIVE_CASINO_ALL_GAMES_PATHS = [
	`${ROUTE_LIVE_SLOTS}${ROUTE_ALL_GAMES}`,
	`${ROUTE_LIVE_CASINO}${ROUTE_ALL_GAMES}`
] as const;
export const LIVE_CASINO_PROVIDER_PATHS = [
	`${ROUTE_LIVE_SLOTS}${ROUTE_PROVIDER}`,
	`${ROUTE_LIVE_CASINO}${ROUTE_PROVIDER}`
] as const;
export const LIVE_CASINO_SUBPROVIDER_PATHS = [
	`${ROUTE_LIVE_SLOTS}${ROUTE_SUBPROVIDER}`,
	`${ROUTE_LIVE_CASINO}${ROUTE_SUBPROVIDER}`
] as const;
export const LIVE_CASINO_SEARCH_PATHS = [
	`${ROUTE_LIVE_SLOTS}${ROUTE_SEARCH}`,
	`${ROUTE_LIVE_CASINO}${ROUTE_SEARCH}`
] as const;

/**
 * Return casino routes based on provided license
 */
export const getCasinoRoutes = (license: string) => {
	// Casino
	const ROUTE_CASINO_BASE = license === LICENSE_DEGA ? ROUTE_SLOTS : ROUTE_CASINO;
	const ROUTE_CASINO_EXPLORE = `${ROUTE_CASINO_BASE}${ROUTE_EXPLORE}` as const;
	const ROUTE_CASINO_GAME = `${ROUTE_CASINO_BASE}${ROUTE_GAME}` as const;
	const ROUTE_CASINO_SEARCH = `${ROUTE_CASINO_BASE}${ROUTE_SEARCH}` as const;
	const ROUTE_CASINO_SUBMENU = `${ROUTE_CASINO_BASE}${ROUTE_SUBMENU}` as const;
	const ROUTE_CASINO_ALL_GAMES = `${ROUTE_CASINO_BASE}${ROUTE_ALL_GAMES}` as const;
	const ROUTE_CASINO_JACKPOT = `${ROUTE_CASINO_BASE}${ROUTE_JACKPOT}` as const;
	const ROUTE_CASINO_MY_GAMES = `${ROUTE_CASINO_BASE}${ROUTE_MY_GAMES}` as const;
	const ROUTE_CASINO_MY_GAMES_LOVED = `${ROUTE_CASINO_BASE}${ROUTE_MY_GAMES_LOVED}` as const;
	const ROUTE_CASINO_MY_GAMES_RECENT = `${ROUTE_CASINO_BASE}${ROUTE_MY_GAMES_RECENT}` as const;
	const ROUTE_CASINO_PROVIDER = `${ROUTE_CASINO_BASE}${ROUTE_PROVIDER}` as const;
	const ROUTE_CASINO_SUBPROVIDER = `${ROUTE_CASINO_BASE}${ROUTE_SUBPROVIDER}` as const;
	const ROUTE_CASINO_QUICK_DEPOSIT = `${ROUTE_CASINO_BASE}${ROUTE_QUICK_DEPOSIT}` as const;

	// Live casino
	const ROUTE_LIVE_CASINO_BASE = license === LICENSE_DEGA ? ROUTE_LIVE_SLOTS : ROUTE_LIVE_CASINO;
	const ROUTE_LIVE_CASINO_EXPLORE = `${ROUTE_LIVE_CASINO_BASE}${ROUTE_EXPLORE}` as const;
	const ROUTE_LIVE_CASINO_GAME = `${ROUTE_LIVE_CASINO_BASE}${ROUTE_GAME}` as const;
	const ROUTE_LIVE_CASINO_SEARCH = `${ROUTE_LIVE_CASINO_BASE}${ROUTE_SEARCH}` as const;
	const ROUTE_LIVE_CASINO_ALL_GAMES = `${ROUTE_LIVE_CASINO_BASE}${ROUTE_ALL_GAMES}` as const;
	const ROUTE_LIVE_CASINO_MY_GAMES = `${ROUTE_LIVE_CASINO_BASE}${ROUTE_MY_GAMES}` as const;
	const ROUTE_LIVE_CASINO_MY_GAMES_LOVED = `${ROUTE_LIVE_CASINO_BASE}${ROUTE_MY_GAMES_LOVED}` as const;
	const ROUTE_LIVE_CASINO_SUBMENU = `${ROUTE_LIVE_CASINO_BASE}${ROUTE_SUBMENU}` as const;

	return {
		ROUTE_CASINO: ROUTE_CASINO_BASE,
		ROUTE_CASINO_GAME,
		ROUTE_CASINO_EXPLORE,
		ROUTE_CASINO_SUBMENU,
		ROUTE_CASINO_MY_GAMES,
		ROUTE_CASINO_MY_GAMES_LOVED,
		ROUTE_CASINO_MY_GAMES_RECENT,
		ROUTE_CASINO_PROVIDER,
		ROUTE_CASINO_SUBPROVIDER,
		ROUTE_CASINO_ALL_GAMES,
		ROUTE_CASINO_JACKPOT,
		ROUTE_CASINO_QUICK_DEPOSIT,
		ROUTE_CASINO_SEARCH,
		ROUTE_LIVE_CASINO: ROUTE_LIVE_CASINO_BASE,
		ROUTE_LIVE_CASINO_EXPLORE,
		ROUTE_LIVE_CASINO_GAME,
		ROUTE_LIVE_CASINO_SEARCH,
		ROUTE_LIVE_CASINO_ALL_GAMES,
		ROUTE_LIVE_CASINO_MY_GAMES,
		ROUTE_LIVE_CASINO_MY_GAMES_LOVED,
		ROUTE_LIVE_CASINO_SUBMENU
	} as const;
};
